import { useEffect, useRef } from "react";

// Google AdSense Ad Banner Component
// Publisher ID: ca-pub-9779110447181018

const ADSENSE_CLIENT = "ca-pub-9779110447181018";

export default function AdBanner({ 
  adSlot, 
  adFormat = "auto", 
  fullWidthResponsive = true,
  className = ""
}) {
  const adRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    // Only initialize once
    if (isInitialized.current) return;
    
    try {
      // Check if adsbygoogle is loaded
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
        isInitialized.current = true;
      }
    } catch (error) {
      // AdSense might not be loaded or blocked - silently continue
    }
  }, []);

  // Placeholder for development/when ads are not configured
  if (!adSlot) {
    return (
      <div className={`bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-sm ${className}`} style={{ minHeight: "90px" }}>
        <span>Advertisement</span>
      </div>
    );
  }

  return (
    <div className={className}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      />
    </div>
  );
}

// Horizontal banner for header/footer
export function HorizontalAd({ className = "" }) {
  return (
    <AdBanner 
      adSlot="" // Add your ad slot ID
      adFormat="horizontal"
      className={`w-full ${className}`}
    />
  );
}

// Sidebar ad for desktop
export function SidebarAd({ className = "" }) {
  return (
    <AdBanner 
      adSlot="" // Add your ad slot ID
      adFormat="vertical"
      className={`hidden lg:block ${className}`}
    />
  );
}

// In-feed ad for venue listings
export function InFeedAd({ className = "" }) {
  return (
    <AdBanner 
      adSlot="" // Add your ad slot ID
      adFormat="fluid"
      className={className}
    />
  );
}
